import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';

import { TabListProps } from './types';

import * as S from './styles';

const AgendaTabList: React.FC<TabListProps> = ({ selectedIndex }) => {
  return (
    <S.TabMenu selectedIndex={selectedIndex} data-testid="tabMenu">
      <S.TabItem data-testid="tabItem">
        <Link to="/care-provider/agenda/calendar">
          <FormattedMessage id="AGENDA.TAB.CALENDAR" />
        </Link>
      </S.TabItem>
      <S.TabItem data-testid="tabItem">
        <Link to="/care-provider/agenda/availability">
          <FormattedMessage id="AGENDA.TAB.AVAILABILITY" />
        </Link>
      </S.TabItem>
    </S.TabMenu>
  );
};

export default AgendaTabList;
